export default "__VITE_ASSET__286983a9__"